"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineHomePage = exports.HomePage = void 0;
const lib_es2015_1 = require("@hodol/web-component-helper/lib-es2015");
const homepage_slide_1_1 = require("../slide/homepage-slide-1");
const homepage_slide_2_1 = require("../slide/homepage-slide-2");
const homepage_slide_3_1 = require("../slide/homepage-slide-3");
const homepage_slide_5_1 = require("../slide/homepage-slide-5");
const homepage_slide_6_1 = require("../slide/homepage-slide-6");
const homepage_slide_7_1 = require("../slide/homepage-slide-7");
const homepage_slide_8_1 = require("../slide/homepage-slide-8");
const homepage_slide_10_1 = require("../slide/homepage-slide-10");
const homepage_slide_11_1 = require("../slide/homepage-slide-11");
const lib_es2015_2 = require("@hodol/dom-helper/lib-es2015");
class HomePage extends HTMLElement {
    constructor() {
        super();
        const shadow = this.attachShadow({ mode: 'open' });
        shadow.innerHTML = `
      <style>
        :host {
          display: block;
          width: 100vw;
          height: 100vh;
          overflow-x: hidden;
          overflow-y: scroll;
        }
      </style>
      <homepage-slide-1></homepage-slide-1>
      <homepage-slide-2></homepage-slide-2>
      <homepage-slide-3></homepage-slide-3>
      <homepage-slide-5></homepage-slide-5>
      <homepage-slide-6></homepage-slide-6>
      <homepage-slide-7></homepage-slide-7>
      <homepage-slide-8></homepage-slide-8>
      <homepage-slide-10></homepage-slide-10>
      <homepage-slide-11></homepage-slide-11>`;
        (0, lib_es2015_2.getQuerySelectOrThrowError)(shadow, 'homepage-slide-11').addEventListener('click-go-to-top-btn', () => {
            this.scrollTop = 0;
        });
    }
}
exports.HomePage = HomePage;
const defineHomePage = (name) => {
    (0, homepage_slide_1_1.defineHomepageSlide1)('homepage-slide-1');
    (0, homepage_slide_2_1.defineHomepageSlide2)('homepage-slide-2');
    (0, homepage_slide_3_1.defineHomepageSlide3)('homepage-slide-3');
    (0, homepage_slide_5_1.defineHomepageSlide5)('homepage-slide-5');
    (0, homepage_slide_6_1.defineHomepageSlide6)('homepage-slide-6');
    (0, homepage_slide_7_1.defineHomepageSlide7)('homepage-slide-7');
    (0, homepage_slide_8_1.defineHomepageSlide8)('homepage-slide-8');
    (0, homepage_slide_10_1.defineHomepageSlide10)('homepage-slide-10');
    (0, homepage_slide_11_1.defineHomepageSlide11)('homepage-slide-11');
    (0, lib_es2015_1.defineIfUndefined)(name, HomePage);
};
exports.defineHomePage = defineHomePage;
